import { Component, OnInit } from '@angular/core';
import { FilterPipe } from '../../pipes/filter.pipe';
import { AdvieswijzerService } from '../advieswijzer.service';
import { Answer } from '../models/answer';
import { AnswerComponent } from './answer/answer.component';

@Component({
    selector: 'app-question-history',
    templateUrl: './question-history.component.html',
    imports: [AnswerComponent]
})
export class QuestionHistoryComponent implements OnInit {
  answers = [];

  constructor(
    private readonly advieswijzerService: AdvieswijzerService,
    private readonly filterPipe: FilterPipe) {
  }

  ngOnInit() {
    this.advieswijzerService.answerChanges
      .subscribe(answerState => {
        if (answerState) {
          this.answers = this.filterPipe.transform(answerState, (answ: Answer) => answ.visible);
        }
      });
  }

  goBack(questionKey: string) {
    this.advieswijzerService.goBackTo(questionKey);
  }
}
